import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, LogIn, Menu, X, Gift, User, Wand2 } from "lucide-react";
import { WHATSAPP_LINK, LOGO_URL } from "../../constants";

export const FloatingHeader = ({ isScrolled, topOffset = 0 }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header 
      className={`fixed left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass shadow-lg' : 'bg-transparent'
      }`}
      style={{ top: `${topOffset}px` }}
      data-testid="floating-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 md:h-28">
          <a href="#" className="flex items-center" data-testid="header-logo">
            <div className={`transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-sm shadow-md px-4 py-2 rounded-xl' : ''}`}>
              <img src={LOGO_URL} alt="DoozyGo" className="h-20 md:h-24 w-auto" />
            </div>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            <a href="#packages" className="nav-link text-[#1E1B4B] hover:text-[#E83E8C] font-medium transition-colors" data-testid="nav-packages">Packages</a>
            <Link to="/doozygo-magic" className="nav-link flex items-center gap-1 text-[#E83E8C] font-semibold transition-colors hover:text-[#D63384]" data-testid="nav-magic"><Wand2 size={15} /> Magic</Link>
            <a href="#book-online" className="nav-link text-[#1E1B4B] hover:text-[#E83E8C] font-medium transition-colors" data-testid="nav-book">Book Online</a>
            <a href="#reviews" className="nav-link text-[#1E1B4B] hover:text-[#E83E8C] font-medium transition-colors" data-testid="nav-reviews">Reviews</a>
            <Link to="/invitations" className="nav-link flex items-center gap-1 text-[#E83E8C] font-semibold transition-colors hover:text-[#D63384]" data-testid="nav-invitations">
              <Gift size={16} /> Free Invites
            </Link>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link to="/my-account" className="flex items-center gap-2 text-[#475569] hover:text-[#E83E8C] px-3 py-2 rounded-full font-medium transition-colors" data-testid="header-my-account-btn">
              <User size={18} /> My Account
            </Link>
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-[#25D366] hover:bg-[#1da851] text-white px-5 py-2.5 rounded-full font-semibold transition-all hover:scale-105 btn-shine" data-testid="header-whatsapp-btn">
              <MessageCircle size={18} /> Book on WhatsApp
            </a>
          </div>

          <button className="md:hidden p-2 text-[#1E1B4B]" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-testid="mobile-menu-btn">
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg py-4 animate-fade-in-up" data-testid="mobile-menu">
            <nav className="flex flex-col gap-2 px-4">
              <a href="#packages" className="py-3 px-4 text-[#1E1B4B] hover:bg-[#FFFAF5] rounded-lg font-medium" onClick={() => setMobileMenuOpen(false)}>Packages</a>
              <Link to="/doozygo-magic" className="py-3 px-4 text-[#E83E8C] hover:bg-[#FFFAF5] rounded-lg font-semibold flex items-center gap-2" onClick={() => setMobileMenuOpen(false)}><Wand2 size={18} /> DoozyGo Magic</Link>
              <a href="#book-online" className="py-3 px-4 text-[#1E1B4B] hover:bg-[#FFFAF5] rounded-lg font-medium" onClick={() => setMobileMenuOpen(false)}>Book Online</a>
              <a href="#reviews" className="py-3 px-4 text-[#1E1B4B] hover:bg-[#FFFAF5] rounded-lg font-medium" onClick={() => setMobileMenuOpen(false)}>Reviews</a>
              <Link to="/invitations" className="py-3 px-4 text-[#E83E8C] hover:bg-[#FFFAF5] rounded-lg font-semibold flex items-center gap-2" onClick={() => setMobileMenuOpen(false)}>
                <Gift size={18} /> Free Invites
              </Link>
              <Link to="/my-account" className="py-3 px-4 text-[#1E1B4B] hover:bg-[#FFFAF5] rounded-lg font-medium flex items-center gap-2" onClick={() => setMobileMenuOpen(false)}>
                <User size={18} /> My Account
              </Link>
              <Link to="/admin" className="py-3 px-4 text-[#475569] hover:bg-[#FFFAF5] rounded-lg font-medium flex items-center gap-2 text-sm" onClick={() => setMobileMenuOpen(false)}>
                <LogIn size={18} /> Admin Login
              </Link>
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="mt-2 flex items-center justify-center gap-2 bg-[#25D366] text-white py-3 rounded-full font-semibold">
                <MessageCircle size={18} /> Book on WhatsApp
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
